const NUMBERS_AFTER_ZERO = 4;

export const hasZeroAfterDot = (price) => /0[.,](0+)[0-9]+/.test(price);

export const getCountAfterDot = (price) =>
  price.toString().match(/0[.,](0*)[0-9]+/)[1].length + NUMBERS_AFTER_ZERO;

export const formatPercent = (number) =>
  number ? `${number.toFixed(2)}` : "0";
